import type { RestRecord, RestRecordMap } from '@libs/data-access/entities'
import type { ReduxState } from '@spa/redux/ReduxState'
import type { Seq } from 'immutable'

import {
  getDataByForeignId,
  getDataByForeignIds
} from '../../services/immutableUtils'
import { getContractsByMembershipId } from '../contracts/selectors'

export const getIsRestsLoading = state => state.rests.getIn(['meta', 'loading'])

export const getRestsByMembershipId = (
  state: ReduxState,
  memberShiftId: number
): RestRecordMap => {
  const contracts = getContractsByMembershipId(state, memberShiftId)

  return getDataByForeignIds(
    state,
    'rests',
    'user_contract_id',
    contracts.keySeq()
  )
}

export const getRestById = (state: ReduxState, restId: number) =>
  state.rests.getIn(['data', restId]) as RestRecord

export const getRestsByContractId = (state: ReduxState, contractId: number) =>
  getDataByForeignId(state, 'rests', 'user_contract_id', contractId)

export const getRestsByContractIds = (
  state: ReduxState,
  contractsIds: Seq.Indexed<number>
) => getDataByForeignIds(state, 'rests', 'user_contract_id', contractsIds)

export const getRestByOriginalShiftId = (state: ReduxState, shiftId: number) =>
  getDataByForeignId(state, 'rests', 'original_shift_id', shiftId)
